import { Button } from "@mui/material";
import MyDialog from "../../Generico/MyDialog";

const HelperTokenAsaas = ({ asaasHelpDialog, onClose }) => {
  return (
    <MyDialog
      isOpen={asaasHelpDialog}
      title="Como conseguir seu token da Asaas"
      handleClose={onClose}
      dialogActions={<Button onClick={onClose}>Fechar</Button>}
    >
      <h3>Passo 1</h3>
      <p>
        Clique no perfil no canto superior direito e então clique em
        <strong> Integrações</strong>
      </p>

      <h3>Passo 2</h3>
      <p>
        Clica na aba <strong>Chaves de API</strong>
      </p>

      <h3>Passo 3</h3>
      <p>
        Clica em <strong>Gerar chave de API</strong> e preencha as informações
        corretamente e então clique em avançar e <strong>Enviar código</strong>
        que irá enviar para o celular cadastrado o código e então clique em{" "}
        <strong>Gerar chave de API</strong>
      </p>

      <h3>Passo 4</h3>
      <p>
        Coloque a chave gerada no campo <strong>Token Asaas</strong> e clique em
        salvar
      </p>
      <p>
        <strong>
          LEMBRE-SE DE GUARDAR O TOKEN EM UM LOCAL SEGURO POR QUE VOCÊ NÃO TERÁ
          ACESSO À ELA NO FUTURO
        </strong>
      </p>
    </MyDialog>
  );
};

export default HelperTokenAsaas;
